'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './news-archive.routes';

export class NewsArchiveComponent {
  constructor(NewsService, Auth, $state, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.currentPage = 1;
    this.itemsPerPage = Config.getPagination("newsArchive");

    this.isAdmin = Auth.isAdminSync;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, 'News Archive');

    this.newsByRange = {
      "Q1-2023": [],
      "Q2-2023": [],
      "Q3-2023": [],
      "Q4-2023": [],

      "Q1-2022": [],
      "Q2-2022": [],
      "Q3-2022": [],
      "Q4-2022": [],

      "Q1-2021": [],
      "Q2-2021": [],
      "Q3-2021": [],
      "Q4-2021": [],


      "2020": [],
      "2019": [],
      "2018": [],
      "older": []
    };

    this.news = [];

    NewsService.query(data => {
      data.forEach(news => {

        if (news.validUntil) {

          if (moment(news.meta.creationDate).isBetween('2023-01-01', '2023-03-31')) {
            this.newsByRange["Q1-2023"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2023-04-01', '2023-06-30')) {
            this.newsByRange["Q2-2023"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2023-07-01', '2023-09-30')) {
            this.newsByRange["Q3-2023"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2023-10-01', '2023-12-31')) {
            this.newsByRange["Q4-2023"].push(news);
          }

          else if (moment(news.meta.creationDate).isBetween('2022-01-01', '2022-03-31')) {
            this.newsByRange["Q1-2022"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2022-04-01', '2022-06-30')) {
            this.newsByRange["Q2-2022"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2022-07-01', '2022-09-30')) {
            this.newsByRange["Q3-2022"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2022-10-01', '2022-12-31')) {
            this.newsByRange["Q4-2022"].push(news);
          }

          else if (moment(news.meta.creationDate).isBetween('2021-01-01', '2021-03-31')) {
            this.newsByRange["Q1-2021"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2021-04-01', '2021-06-30')) {
            this.newsByRange["Q2-2021"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2021-07-01', '2021-09-30')) {
            this.newsByRange["Q3-2021"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2021-10-01', '2021-12-31')) {
            this.newsByRange["Q4-2021"].push(news);
          }

          else if (moment(news.meta.creationDate).isBetween('2020-01-01', '2020-12-31')) {
            this.newsByRange["2020"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2019-01-01', '2019-12-31')) {
            this.newsByRange["2019"].push(news);
          }
          else if (moment(news.meta.creationDate).isBetween('2018-01-01', '2018-12-31')) {
            this.newsByRange["2018"].push(news);
          }

          else if (moment(news.meta.creationDate).isBetween('1999-12-31', '2017-12-31')) {
            this.newsByRange["older"].push(news);
          }

        }
      })
    });

  }

  switchNewsByRange(newsRange) {
    this.news = this.newsByRange[newsRange];
  }

  countNewsByRange(newsRange) {
    return this.newsByRange[newsRange].length;
  }
}

export default angular.module('conduuApp.newsArchive', [uiRouter])
  .config(routes)
  .component('newsArchive', {
    template: require('./news-archive.html'),
    controller: NewsArchiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/news/archive/news-archive.component.js